import {Text, View } from 'react-native';
import DoubleTap from './components/DoubleTap';
import {useState} from 'react';
import { ReactComponent as Logo } from './images/SOTHMlogo.svg';

function CardView(props) {
    const [flipped, setFlipped] = useState(false);

    const toggleFlip = () => {
        setFlipped(!flipped)        
    };

return (
    <DoubleTap onDoubleTap={toggleFlip}>
    <div class="wrapper">
        <div  class={`single-card ${ flipped ? 'flipped':'' }`}>
       
            <div style={{backgroundImage: `url(${props.data.image})`}} class="front tooltip">
            <span class="tooltiptext">Double click card for more info</span>
            </div>
           
            <div class="back" >
                <div class="content">
                <div class="textInset">
                {props.data.welcomeText 
                ?  <View>
                        <Text><div class="welcome" dangerouslySetInnerHTML={{__html: props.data.welcomeText}} /></Text>
                        <Logo className="rotating" style={{ marginTop: '10px', height:'200px', width:'200px', alignSelf:'center'}} />                        
                    </View>
                :  <View>                            
                    <Text><h3>{props.data.cardName}</h3></Text> 
                    <Text><div style={{ textAlign: 'left', fontStyle: 'italic'}} dangerouslySetInnerHTML={{__html: props.data.lyricQuote}} /></Text>            
                    <Text style={{marginTop: 20}}> 
                        <div dangerouslySetInnerHTML={{__html: props.data.description}} />
                    </Text>
                    
                    <Text style={{marginTop: 10, fontWeight: 'bold', fontStyle: 'italic',}}>Divinatory Meanings</Text>
                    <Text>{props.data.divinatoryMeaning}</Text>
                    <Text style={{marginTop: 10, fontWeight: 'bold', fontStyle: 'italic'}}>Inspired by the song:</Text>
                    <Text >{props.data.songTitle}</Text> 
                    
                    <Text style={{marginTop: 10, fontWeight: 'bold', fontStyle: 'italic'}}>Artwork by</Text>
                    <Text>{props.data.artist}</Text>
                    <Text><a href={props.data.artistLink} target="_blank" rel="noopener noreferrer">{props.data.artistHandle}</a></Text>
                    </View>
               }
               
                </div>
            
                </div>
            </div>
        </div>
    </div>
    </DoubleTap>
)};

  
export default CardView;